export default __webpack_public_path__ + "c3f600ad4a4531621bd79efcc5964f78.png";